import { render, staticRenderFns } from "./bindAccount.vue?vue&type=template&id=e276bd58&scoped=true"
import script from "./bindAccount.vue?vue&type=script&lang=js"
export * from "./bindAccount.vue?vue&type=script&lang=js"
import style0 from "./bindAccount.vue?vue&type=style&index=0&id=e276bd58&lang=less&scoped=true"
import style1 from "./bindAccount.vue?vue&type=style&index=1&id=e276bd58&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e276bd58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e276bd58')) {
      api.createRecord('e276bd58', component.options)
    } else {
      api.reload('e276bd58', component.options)
    }
    module.hot.accept("./bindAccount.vue?vue&type=template&id=e276bd58&scoped=true", function () {
      api.rerender('e276bd58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/pricing/bindAccount.vue"
export default component.exports